import React, { useEffect } from 'react';
import { TrackingClient } from '@sparefoot/tracking-client';
import isBrowser from 'utils/isBrowser';

function withPageViewTracking(pageType) {
	return (Component) => {
		const WithPageViewTracking = (props) => {
			useEffect(() => {
				if (isBrowser() && TrackingClient) {
					const metaTitle = document.title || pageType;
					TrackingClient.trackPageView({
						page_name: metaTitle,
						page_type: pageType,
					});
				}
			}, []);

			return <Component {...props} />;
		};
		WithPageViewTracking.displayName = `withPageViewTracking(${Component.displayName || Component.name || 'Component'})`;
		return WithPageViewTracking;
	};
}

export default withPageViewTracking;
